import { ReactElement, ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

const TRANSLATION_PREFIX = 'Modals:OrderMethod:OrderMethodModal';

interface PromoCodeButtonProps {
  code: string;
  children?: ReactNode;
}

function PromoCodeButton({ code, children }: PromoCodeButtonProps): ReactElement {
  const { t } = useTranslation(null, { keyPrefix: TRANSLATION_PREFIX });

  const handleCopy = (): void => {
    navigator.clipboard?.writeText(code);
    toast.success(t('no_couriers.copied'));
  };

  return (
    <button type="button" onClick={handleCopy} className="font-bold underline">
      {children ?? code}
    </button>
  );
}

interface Props {
  code?: string;
}

/**
 * Inline copy shown when delivery has no available couriers. When a master promo code is present
 * it is rendered as a click-to-copy element inside the localized sentence.
 */
export default function NoCouriersErrorContent({ code }: Props): ReactElement {
  const { t } = useTranslation(null, { keyPrefix: TRANSLATION_PREFIX });

  if (!code) {
    return <>{t('no_couriers.without_code')}</>;
  }

  return (
    <Trans
      t={t}
      i18nKey="no_couriers.with_code"
      values={{ code }}
      components={{ PromoCode: <PromoCodeButton code={code} /> }}
    />
  );
}
